module.exports = __webpack_public_path__ + "img/logo-footer.754289a0.svg";